import { render, staticRenderFns } from "./WidgetLivraisons.vue?vue&type=template&id=49c21fe2&"
import script from "./WidgetLivraisons.vue?vue&type=script&lang=js&"
export * from "./WidgetLivraisons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports